import { IFluxStandardAction } from "@common";
import { knownMessages } from "./feedback.messages";

const defaultState = { message: "" };

export default function(
  state = defaultState,
  action: IFluxStandardAction<any>
) {
  return action.meta && action.meta.feedback
    ? { message: knownMessages[action.meta.feedback] || "" }
    : state;
}
